import { render, staticRenderFns } from "./ModuleEthBlockInfo.vue?vue&type=template&id=65177d6e&scoped=true"
import script from "./ModuleEthBlockInfo.vue?vue&type=script&lang=js"
export * from "./ModuleEthBlockInfo.vue?vue&type=script&lang=js"
import style0 from "./ModuleEthBlockInfo.vue?vue&type=style&index=0&id=65177d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65177d6e",
  null
  
)

export default component.exports